import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DonneReferenceService } from '../../../shared/services/donne-reference.service';

@Component({
  selector: 'app-feature-inactive',
  templateUrl: './feature-inactive.component.html',
  styleUrls: ['./feature-inactive.component.scss'],
  standalone: false
})
export class FeatureInactiveComponent implements OnInit {
  numero1: string;
  numero2: string;
  constructor(private readonly _router: Router, private readonly _donneeReferencesService: DonneReferenceService) {}

  ngOnInit(): void {
    this.numero1 = this._donneeReferencesService.numerosDemandeSupport.montreal;
    this.numero2 = this._donneeReferencesService.numerosDemandeSupport.sansFrais;
  }

  navigateTo(target: string): void {
    this._router.navigateByUrl(target);
  }
}
